module.exports = __webpack_public_path__ + "static/media/Hybrid_Icon.74d434b8.svg";